<template>
  <div class="dialog-wrap">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-drawer
      title="批量修改"
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="520"
      destroy-on-close
      append-to-body
    >
      <div class="content-wrap">
        <div class="dialog-title">
          <p class="title">修改教师与授课模式</p>
          <p class="total">已选择{{ originArray.length }}课时</p>
        </div>
        <el-form
          class="main-form"
          size="mini"
          :model="form"
          ref="mainForm"
          :rules="rules"
          label-width="110px"
        >
          <el-form-item
            label="授课教师:"
            prop="teacher_ids"
            style="width: 440px"
          >
            <!-- <teacher-selector
              :classId="form.class_id"
              :originIds.sync="form.teacher_ids"
              :originItems.sync="form.teacher_list"
              :noConflict="true"
            ></teacher-selector> -->
            <el-select
              v-model="form.teacher_ids"
              multiple
              style="display: none"
            ></el-select>
            <div class="mwow-common-form-multi-select">
              <div class="input-wrap">
                <p class="text">
                  已添加<span class="mwow-green">{{
                    form.teacher_list.length
                  }}</span
                  >人
                </p>
                <all-teacher-selector
                  :origin-data="form.teacher_list"
                  @change="handleTeacherSelect"
                  :single="false"
                >
                  <el-button class="mwow-button success">添加</el-button>
                </all-teacher-selector>
              </div>
              <div class="show-wrap" v-show="form.teacher_list.length > 0">
                <span
                  v-for="item in form.teacher_list"
                  :key="item.teacher_id"
                  >{{ item.name }}</span
                >
              </div>
            </div>
          </el-form-item>
          <el-form-item label="授课模式:" prop="lesson_type">
            <el-radio-group
              v-model="form.lesson_type"
              @change="handleLessonTypeChange"
            >
              <el-radio-button :label="1">线下 - 门店授课</el-radio-button>
              <el-radio-button :label="2">线上 - 直播授课</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="开播教师:"
            v-if="form.lesson_type === 2"
            prop="main_teacher_id"
          >
            <el-select
              v-model="form.main_teacher_id"
              placeholder="请选择"
              style="width: 282px"
            >
              <el-option
                v-for="item in form.teacher_list"
                :key="item.teacher_id"
                :label="item.name"
                :value="item.teacher_id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="footer">
          <div class="btns">
            <div class="mwow-button-filled mini" @click="closeDialog">取消</div>
            <div class="mwow-button-filled mini success" @click="handleSubmit">
              保存
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 冲突弹窗 -->
    <el-dialog
      title="提示"
      destroy-on-close
      :visible.sync="conflictDialogVisible"
      append-to-body
    >
      <conflict-dialog
        :conflictData="conflictDialogData"
        :visible.sync="conflictDialogVisible"
        @submit="conflictConfirm"
      ></conflict-dialog>
    </el-dialog>
  </div>
</template>
<script>
import allTeacherSelector from "../../classList/allTeacherSelector.vue";
import conflictDialog from "../log/conflictDialog.vue";
import { lessonTeacherConflictCheckApi } from "@/api/classSchedule";
import { mutiEditTeacherData, mutiEditTeacherApi } from "@/api/lesson";

export default {
  name: "classDetailLogMutiEditTeacher",
  components: {
    allTeacherSelector,
    conflictDialog,
  },
  // @Prop() ori!: any[];
  // @Prop() cid!: number;
  props: ["ori", "cid"],
  data() {
    return {
      originArray: [],
      form: {
        class_id: 0,
        lesson_type: 1,
        main_teacher_id: "",
        teacher_ids: [],
        teacher_list: [],
      },
      dialogVisible: false,
      rules: {
        teacher_ids: [
          { required: true, message: "请选择授课教师", trigger: "change" },
        ],
        main_teacher_id: [
          { required: true, message: "请选择开播教师", trigger: "change" },
        ],
      },
      conflictDialogVisible: false,
      conflictDialogData: {},
    };
  },
  methods: {
    openDialog() {
      this.form = {
        class_id: this.cid,
        lesson_type: 1,
        main_teacher_id: "",
        teacher_ids: [],
        teacher_list: [],
      };
      this.dialogVisible = true;
      this.originArray = [...this.ori];
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleLessonTypeChange() {
      if (!this.form.main_teacher_id) {
        if (this.form.teacher_ids.length > 0) {
          this.form.main_teacher_id = this.form.teacher_ids[0];
        } else {
          this.form.main_teacher_id = "";
        }
      }
    },
    handleTeacherSelect(arr) {
      this.form.teacher_list = arr;
      this.form.teacher_ids = arr.map((item) => {
        return item.teacher_id;
      });
    },
    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          this.handleConflictCheck();
        }
      });
    },
    handleConflictCheck() {
      lessonTeacherConflictCheckApi({
        class_id: Number(this.cid),
        lesson_ids: this.originArray,
        teacher_ids: this.form.teacher_ids,
      }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.conflict) {
            this.conflictDialogVisible = true;
            this.conflictDialogData = res.data;
          } else {
            this.conflictConfirm();
          }
        }
      });
    },
    conflictConfirm() {
      const params = {
        lesson_ids: this.originArray,
        class_id: this.cid,
        teacher_ids: this.form.teacher_ids,
        main_teacher_id: Number(this.form.main_teacher_id),
        lesson_type: this.form.lesson_type,
      };
      mutiEditTeacherApi(params).then(() => {
        this.$message({
          type: "success",
          message: "编辑成功",
        });
        this.closeDialog();
        this.$emit("change");
      });
    },
  },

  // @Watch("form.teacher_ids", { immediate: false, deep: false })
  // onTeacherIdsChange(n) {
  //   this.form.main_teacher_id = n[0];
  // }
  watch: {
    "form.teacher_ids": {
      handler(n, o) {
        this.form.main_teacher_id = n[0];
      },
      immediate: false,
      deep: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-wrap {
  display: inline-block;
}
.content-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .dialog-title {
    padding: 20px 0;
    margin: 0 47px;
    border-bottom: 1px dashed #e7e8ea;
    .title {
      font-size: 14px;
      line-height: 18px;
      color: #5c5d5e;
      margin-bottom: 17px;
      font-weight: bold;
    }
    .total {
      font-size: 12px;
      line-height: 16px;
      color: #ffb940;
    }
  }
  .main-form {
    flex: 1;
    padding: 16px 0;
    .tail {
      margin-left: 6px;
      color: #5c5d5e;
      font-size: 12px;
    }
  }
  .footer {
    padding: 20px;
    .btns {
      text-align: right;
      .mwow-button-filled {
        margin-left: 10px;
      }
    }
  }
}
</style>
